"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const inventory_stock_entity_1 = require("../inventory/inventory-stock.entity");
const order_line_item_entity_1 = require("../orders/order-line-item.entity");
const product_category_entity_1 = require("./product-category.entity");
let Product = class Product {
};
exports.Product = Product;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Product.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 20, unique: true }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "sku", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 200 }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 80, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "category", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToMany)(() => product_category_entity_1.ProductCategory, (category) => category.products, { cascade: false }),
    (0, typeorm_1.JoinTable)({
        name: 'product_category_map',
        joinColumn: { name: 'productId', referencedColumnName: 'id' },
        inverseJoinColumn: { name: 'categoryId', referencedColumnName: 'id' },
    }),
    tslib_1.__metadata("design:type", Array)
], Product.prototype, "categories", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2 }),
    tslib_1.__metadata("design:type", Number)
], Product.prototype, "unitPrice", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 50, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "unit", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 200, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Product.prototype, "imageUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], Product.prototype, "isActive", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => inventory_stock_entity_1.InventoryStock, (s) => s.product, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Product.prototype, "stockLocations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => order_line_item_entity_1.OrderLineItem, (li) => li.product),
    tslib_1.__metadata("design:type", Array)
], Product.prototype, "lineItems", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Product.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Product.prototype, "updatedAt", void 0);
exports.Product = Product = tslib_1.__decorate([
    (0, typeorm_1.Entity)('products')
], Product);
